<script lang="ts" setup>
import { useElementVisibility, watchOnce } from "@vueuse/core"

const { getImage } = useImage()
const target = useTemplateRef("section")
const targetIsVisible = useElementVisibility(target)
const isVisible = ref(false)

watchOnce(targetIsVisible, () => {
	isVisible.value = true
})

const image = getImage("/website/cta-bg.png", {
	modifiers: { height: 504, format: "webp" },
})

const style = computed(() => {
	if (isVisible.value) {
		return {
			backgroundImage: `url(${image.url})`,
		}
	}
	return {}
})
</script>

<template>
	<section
		ref="section"
		:style="style"
		class="bg-cover bg-no-repeat p-5 md:p-10 lg:px-65 lg:py-30">
		<div
			data-aos="fade-up"
			class="flex flex-wrap items-center justify-center gap-10 rounded-3xl bg-background/60 p-5 container lg:justify-between lg:p-10">
			<div class="flex flex-col items-center justify-center lg:items-start">
				<h3 class="mb-4 text-center text-4xl font-sarv lg:text-start">
					همین حالا رایگان استفاده کن !
				</h3>

				<p class="text-center lg:text-start">
					رایگان شروع کن و اگر از کیفیت سرویس ها راضی بودی، پلنت رو ارتقا بده
				</p>

				<NuxtLink href="/app/login">
					<Btn class="mt-12 bg-foreground px-4 text-white hover:bg-foreground/60">
						ثبت نام
					</Btn>
				</NuxtLink>
			</div>

			<NuxtImg
				loading="lazy"
				format="webp"
				src="/website/cta-rocket.png"
				width="172"
				height="184" />
		</div>
	</section>
</template>
